var module = 'profile', name = 'profile/config/locales/fr_CA.json', content = {
  "home": {
    "greeting": "Bienvenue, {{ patientFirstName }}",
    "title": "Mes rendez-vous",
    "title_with_name": "Rendez-vous de {{name}}",
    "assigment_labels": {
      "year": "Année",
      "date": "Date",
      "time": "Heure",
      "reason": "Type de rendez-vous",
      "request_date": "Date de la demande",
      "cancellation_reason": "Raison de l'annulation",
      "cancellation_date": "Date de l'annulation",
      "professional": "Professionnel de la santé",
      "location": "Lieu",
      "visit_reason": "Raison de la visite",
      "time_range": "à",
      "manitoba_language_access": "Services linguistiques"
    },
    "upcoming": {
      "title": "Rendez-vous à venir",
      "help": "Pour chaque rendez-vous, deux rappels vous seront envoyés par courriel :<br>48 h à l'avance et 1 h précédant votre rendez-vous",
      "none": "Tous vos rendez-vous s'affichent ici avec la date, l'heure et le nom du professionel de la santé que vous rencontrez.",
      "no_fmd_none": "Tous vos rendez-vous s'affichent ici avec la date et l'heure.",
      "reminder": "Un rappel vous sera envoyé 48 heures à l'avance, puis 1 heure avant le rendez-vous.",
      "warning": {
        "reason_title": "Vous ne pouvez pas prendre d'autres rendez-vous puisque vous avez un ou plusieurs rendez-vous à venir",
        "phone_title": "Pour plus d'information, communiquez avec nous"
      },
      "attachments": {
        "title": "Pièces jointes",
        "show": "Montrer",
        "hide": "Cacher"
      },
      "additional_info": {
        "title": "Indication supplémentaire",
        "details": "Détails",
        "show_less": "Voir moins"
      }
    },
    "appointment_requests": {
      "title": "Demandes de service",
      "cancelled_title": "Demandes de service annulées",
      "cancel_appointment_request": "Annuler cette demande",
      "description_line1": "Cette section liste toutes les demandes de services qui sont actuellement traitées par la clinique. ",
      "description_line2": "Vous recevrez un avis de rendez-vous lorsque votre demande sera traitée avec succès. ",
      "description_line3": "Si, pour une raison quelconque, votre demande de service se verrait refusée, un membre du personnel de la clinique communiquera avec vous."
    },
    "history": {
      "title": "Historique des rendez-vous",
      "none": "L'historique des rendez-vous vous permet d'avoir une vue d'ensemble sur votre dossier médical et la fréquence de vos visites."
    },
    "recall_list": {
      "title": "Rappels de prise de rendez-vous",
      "recall_name": "Nom du rappel",
      "professionnal": "Professionnel(s)",
      "actions": "Actions",
      "appointment_ready": "Prendre un rendez-vous",
      "appointment_not_ready": "Vous recevrez un rappel de la clinique lorsque les disponibilités seront ouvertes pour vous.",
      "appointment_ready_multiple_reasons": "Vous pouvez maintenant prendre un rendez-vous. Pour ce faire, utilisez les boutons en haut de cette page."
    },
    "warnings": {
      "no_offering": "Il n'y a aucune offre de rendez-vous disponible.",
      "family_physician": "Vous ne pouvez pas prendre d'autres rendez-vous avec votre {{familyDoctorLabel}} puisque vous avez un ou plusieurs rendez-vous à venir.",
      "walkin": "Vous ne pouvez pas réserver plus d'une place à la fois au sans rendez-vous.",
      "other_offering": "Vous ne pouvez pas réserver plus d'une place à la fois pour un rendez-vous de type {{description}}.",
      "no_family_doctor": "Vous ne pouvez pas prendre de rendez-vous avec votre {{familyDoctorLabel}} puisque vous n'avez pas de {{familyDoctorLabel}} à cette clinique ou parce que votre {{familyDoctorLabel}} n'offre pas le service de rendez-vous en ligne.",
      "self_registration": "Afin d'accélérer le processus d'accueil et la validation de votre identité lors de votre première visite à la clinique, nous vous invitons à compléter vos informations personnelles à partir de la section",
      "noshow": "Il semblerait que vous ayez manqué l'un de vos rendez-vous. Par conséquent, vous devez communiquer avec la clinique pour prendre un autre rendez-vous.",
      "prevent_booking": "Veuillez nous contacter pour prendre rendez-vous."
    },
    "patient_message": {
      "details": "Détails",
      "show_less": "Voir moins"
    },
    "take_appointment": "Prendre un rendez-vous",
    "cancel_appointment": "Annuler ce rendez-vous",
    "confirm_appointment": "Confirmer ma présence",
    "confirmed_appointment": "Présence confirmée",
    "join_this_appointment": "Rejoindre ce rendez-vous",
    "copy_the_link": "Copier le lien de ce rendez-vous",
    "link_will_appear": "Le lien de votre rendez-vous apparaîtra ici environ 10 minutes avant le début de votre consultation. S'il n'apparaît pas dans ce délai, veuillez contacter la clinique pour corriger la situation.",
    "virtual_meeting_failed": "Un problème est survenu durant la création de votre lien de consultation. Pour régulariser cette situation, veuillez contacter la clinique."
  },

  "update": {
    "menu_trigger": "Retour au menu",
    "tabs": {
      "my_profile": "Mon profil",
      "manage_notifications": "Mes notifications",
      "change_password": "Mon mot de passe",
      "change_email": "Mon adresse courriel",
      "informations": "Mes informations personnelles",
      "reminders": "Mes rappels de rendez-vous"
    },
    "profile": {
      "title": "Mon profil",
      "information": "Votre profil contient l'ensemble des informations reliées à l'accès à votre compte et la prise de rendez-vous.",
      "linkedPatients": {
        "title": "Associer une personne à mon compte",
        "information": "Vous pouvez associer des personnes à votre compte, des membres de votre famille par exemple, et gérer la prise de rendez-vous à partir d'un seul et même compte.",
        "subtitle": "Personne(s) associée(s) à votre compte",
        "table": {
          "name": "Nom",
          "hin": "NAM",
          "phin": "NIP",
          "generic_hin": "NIP",
          "blank": "Aucune association",
          "added": "Personne associée"
        },
        "associate": "Associer un nouveau patient",
        "associateButton": "Associer",
        "labels": {
          "hin": "NAM",
          "phin": "NIP",
          "first_name": "Prénom",
          "last_name": "Nom",
          "sharingConsent": "Consentement de partage"
        },
        "sharingConsentWarning": "En cochant cette case, vous acceptez l'<a ui-sref=\"patient_agreement({locale: 'fr_CA'})\" target=\"_blank\">entente d'utilisation</a> pour la personne que vous ajoutez au compte.",
        "helpText": "Veuillez compléter les champs ci-dessous pour associer une personne à votre compte.",
        "unlink_patient_action": "Dissocier du compte",
        "unlink_patient_text": "Dissocier cette personne de votre compte?",
        "unlink_patient_cancel": "Annuler",
        "unlink_patient_confirm": "Dissocier",
        "error": {
          "pattern": "Le numéro d'assurance maladie doit être sous la forme de AAAA 1111 1111",
          "required_hin": "Vous devez entrer un NAM valide.",
          "required": "Champ requis",
          "already_linked": "La personne est déjà associée à un autre compte.",
          "no_match": "Le NAM et le nom de la personne ne correspondent pas.",
          "already_confirmed": "Il est impossible d’associer cette personne, car elle gère déjà son propre compte.",
          "not_found": "La personne n'a pas été trouvée.",
          "self": "Vous ne pouvez pas associer votre propre compte."
        }
      },
      "last_updated": {
        "clinic": "Dernière mise à jour le {{date}} par la clinique",
        "yourself": "Dernière mise à jour le {{date}} par vous",
        "other_patient": "Dernière mise à jour le {{date}} par {{patientName}}"
      }
    },
    "notification": {
      "heading": "Gérer mes notifications",
      "legend": "Je désire recevoir une notification par courriel concernant des ouvertures dans l'horaire de mon {{familyDoctorLabel}} :",
      "label_md": "Notifications pour",
      "label_new": "À chaque nouvelle série de disponibilités",
      "label_next": "Uniquement à la prochaine série de disponibilités",
      "label_specific": "Seulement pour les disponibilités dans la semaine du",
      "label_none": "Je ne souhaite pas recevoir de notifications",
      "update_success": "Vos préférences de notifications ont été enregistrées avec succès."
    },
    "reminders": {
      "title": "Mes rappels de rendez-vous",
      "information": "Veuillez sélectionner le meilleur moyen de vous rejoindre pour vos rappels de rendez-vous.",
      "contact_method_kinds": {
        "email": "Courriel",
        "sms": "Message texte",
        "phone": "Téléphone automatisé"
      },
      "labels": {
        "reminder_method_kind": "Méthode de contact"
      },
      "current": {
        "email": "Adresse courriel actuelle",
        "sms": "Numéro de cellulaire actuel",
        "phone": "Numéro de téléphone actuel"
      },
      "errors": {
        "no_mobile_number": "Vous devez d'abord ajouter un numéro de cellulaire dans votre profil.",
        "no_phone_number": "Vous devez d'abord ajouter un numéro de téléphone dans votre profil."
      },
      "add_phone": "Ajouter un numéro de téléphone",
      "add_mobile": "Ajouter un numéro de cellulaire",
      "no_phone": "Aucun numéro de téléphone",
      "no_mobile": "Aucun numéro de cellulaire",
      "update_success": "Vos préférences de rappels ont été enregistrées avec succès.",
      "update_success_added_phone": "Vos préférences de rappel et vos numéros de téléphone ont été modifiées avec succès",
      "current_method_email_go_edit": "Votre adresse courriel est modifiable à partir de l'onglet"
    },
    "password": {
      "heading": "Mon mot de passe",
      "subtitle": "Le mot de passe doit contenir au minimum 8 caractères, dont au moins une majuscule et un chiffre.",
      "labels": {
        "password": "Mot de passe actuel",
        "newPassword": "Nouveau mot de passe",
        "confirmNewPassword": "Confirmation du nouveau mot de passe"
      },
      "errors": {
        "required": "Champ requis",
        "requiredPassword": "Veuillez entrer votre mot de passe actuel.",
        "requiredNewPassword": "Veuillez saisir votre nouveau mot de passe.",
        "requiredConfirmNewPassword": "Vous avez oublié de confirmer votre mot de passe.",
        "noMatch": "Vos mots de passe ne correspondent pas",
        "passwordRequirements": "Votre mot de passe doit contenir au moins une majuscule et un chiffre",
        "minlength": "Votre mot de passe doit avoir plus de 8 caractères",
        "maxlength": "Votre mot de passe doit avoir moins de 256 caractères",
        "wrongPassword": "Mauvais mot de passe",
        "samePassword": "Vous devez changer votre mot de passe",
        "unexpected": "Une erreur s'est produite, veuillez réessayer"
      },
      "confirmation": {
        "title": "Voulez-vous réellement modifier votre mot de passe?",
        "confirm": "Confirmer la modification",
        "dismiss": "Annuler",
        "otherClinics": "La modification s'appliquera aussi à vos comptes ailleurs dans le réseau :"
      },
      "updateSuccess": "Votre mot de passe a été modifié avec succès."
    },
    "email": {
      "heading": "Mon adresse courriel",
      "subtitle": "L'adresse courriel est utilisée pour vous connecter à votre compte et recevoir les rappels et les notifications de rendez-vous. Lorsque vous modifiez votre adresse, nous vous envoyons un courriel vous invitant à confirmer cette modification.",
      "hospital_booking_subtitle": "L'adresse courriel est utilisée pour vous connecter à votre compte. Lorsque vous modifiez votre adresse, nous vous envoyons un courriel vous invitant à confirmer cette modification.",
      "currentEmail": "Adresse courriel actuelle",
      "pendingConfirmation": "Vous devez compléter votre changement d'adresse courriel ou l'annuler afin de pouvoir modifier votre adresse courriel à nouveau.",
      "pendingEmail": "Adresse courriel en attente de confirmation : {{ pendingEmail }}",
      "reauth_warning": "Une re-authentification vous sera demander pour changer votre addresse couriel.",
      "labels": {
        "newEmail": "Nouvelle adresse courriel",
        "confirmNewEmail": "Confirmation de la nouvelle adresse courriel"
      },
      "errors": {
        "requiredNewEmail": "Veuillez entrer votre nouvelle adresse courriel.",
        "requiredConfirmNewEmail": "Veuillez confirmer votre adresse courriel.",
        "noMatch": "Les adresses courriel ne correspondent pas.",
        "email": "Adresse courriel invalide",
        "sameEmail": "Cette adresse courriel est la même que votre adresse actuelle.",
        "unexpected": "Une erreur s'est produite, veuillez réessayer",
        "alreadyTaken": "Cette adresse courriel est déjà utilisée."
      },
      "confirmation": {
        "explanations": "Un courriel vous invitant à confirmer cette modification vous sera envoyé. Le changement ne sera effectif qu'après avoir réalisé cette étape.",
        "title": "Voulez-vous réellement modifier votre adresse courriel?",
        "otherClinics": "La modification s'appliquera aussi à vos comptes ailleurs dans le réseau :"
      },
      "banner": {
        "title": "Il vous faut encore confirmer votre changement d'adresse courriel. Un courriel de confirmation a été envoyé à {{ newEmail }}. Le changement ne sera effectif qu'après avoir réalisé cette étape.",
        "resend": "Renvoyer la confirmation",
        "cancel": "Annuler la demande de modification",
        "success": "Votre adresse courriel a été modifiée avec succès!",
        "error": "Une erreur s'est produite lors de la confirmation de la nouvelle adresse courriel. Veuillez vous connecter à nouveau et cliquer sur le bouton Renvoyer la confirmation.",
        "errorAlreadyConfirmed": "Votre nouvelle adresse courriel a déjà été confirmée. Vous pouvez dès maintenant vous connecter."
      },
      "updateSuccess": "Votre adresse courriel a été modifiée avec succès."
    },
    "informations": {
      "cannot_update": "Il n'est pas possible de modifier vos informations personnelles sur le site internet. Pour ce faire, vous devez téléphoner à la clinique.",
      "labels": {
        "gender": "Sexe",
        "last_name": "Nom",
        "first_name": "Prénom",
        "birthdate": "Date de naissance",
        "age": "Âge",
        "hin": "NAM",
        "phin": "NIP",
        "generic_hin": "NIP",
        "hin_expiration": "Date d'expiration",
        "father_name": "Nom du père",
        "mother_name": "Nom de la mère",
        "conjoint_name": "Nom du conjoint(e)",
        "address": "Adresse postale",
        "city": "Ville",
        "province": "État/Province",
        "country": "Pays",
        "zip": "Code postal",
        "email": "Adresse courriel",
        "phone": "Téléphone",
        "allergies": "ALLERGIES (Inscrire <i>Aucune</i> si vous n'en avez pas)",
        "medical_history": "ANTÉCÉDENTS MÉDICAUX (Inscrire <i>Aucun</i> si vous n'en avez pas)"
        },
      "list_items": {
        "years_old": "ans"
        },
      "titles": {
        "informations": "Renseignements personnels",
        "address" : "Coordonnées",
        "contacts": "Adresse courriel et téléphone",
        "medical_infos": "Allergies et antécédents médicaux"
      },
      "actions": {
        "edit": "Modifier",
        "add_phone": "Ajouter un numéro de téléphone"
      },
      "messages": {
        "masked_informations": "Vos informations personnelles sont masquées pour des raisons de sécurité. Celles-ci apparaîtront une fois que votre identité aura été validée lors de votre première visite à la clinique.",
        "showed_informations": "Les informations ci-dessous aideront le personnel de la clinique à confirmer votre identité.",
        "intro": "Votre adresse courriel est modifiable à partir de l'onglet <strong>Mon adresse courriel</strong>.",
        "order": "Votre numéro de rappels est modifiable à partir de l’onglet.",
        "reminders_number": "Numéro de rappels"
      }
    },
    "btn_cancel": "Annuler",
    "btn_submit": "Enregistrer"
  }
}
;
angular.module(module).run(['$translationCache', function($translationCache) {
  $translationCache.put(name, content);
}]);
module.exports = name;


//////////////////
// WEBPACK FOOTER
// ./profile/config/locales/fr_CA.json
// module id = 869
// module chunks = 0